// We need this to use useSelector  (You can Export this as a react-hook to use separately)
import { useDispatch, useSelector } from "react-redux";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch();
export const useTypedSelector = useSelector;
